window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */
function trackCartUpdate() {
    $(document).on('click', '#cart-update', function(e) {
        e.preventDefault();
        const is_checkout = false;
        const updates = buildCartUpdateObject();
    		updateCart(updates, is_checkout);
    });
}

function trackItemRemoval(){
    $(document).on('click', '.cart-remove', function (e) {
        e.preventDefault();
        const is_checkout = false;
        const { itemKey, core } = this.dataset;
        const updates = getItemWithCoreRemoveObject($(this));
        updateCart(updates, is_checkout);
    });
}

function getItemWithCoreRemoveObject($element) {
    const line_key = $element.attr('data-item-key');
    const line_added = $element.attr('data-core');
    const target_core_key = $(`[data-for-core="${line_added}"]`).attr('id');

    const updates = {
      [line_key]: 0,
    };

    if (target_core_key) {
      updates[target_core_key] = 0;
    }
   
    return updates;
}

// update cart
function buildCartUpdateObject(){
	let update_object = {};
    $('.cart-item').each(function(){
        if(isKitInOrCore($(this))){
            return true;
        }

		const line_key = $(this).attr('id');
		const line_qty = $(this).find('.cart-item-quantity').val();
		update_object[line_key] = line_qty;
    
        if (typeof $(this).data('core') !== 'undefined'){
            update_object = getCoreUpdateObject($(this), update_object);
        }
    });
    return update_object;
}

function isKitInOrCore($element){
    return (typeof $element.data('for-core') !== 'undefined');
}

function getCartUpdateKitParamString(cart_item, updateParamString){
    var mainItemQuantity = cart_item.find('.cart-item-quantity').val(),
        productID = cart_item.attr('data-for-kit');
    
    // kit in items
    $('.cart-item[data-kit-in="' + productID + '"').each(function () {
        var lineItemKey = $(this).attr('id');
        updateParamString += '&updates[' + lineItemKey + ']=' + mainItemQuantity + '&';
        $(this).find('.cart-item-quantity').val(mainItemQuantity);
    });

    // kit with cores
    if(typeof cart_item.data('core') !== 'undefined'){
        updateParamString = (cart_item, updateParamString);
    }
    return updateParamString;
}

function getCoreUpdateObject($cart_item, update_object){
  	const main_added = $cart_item.attr('data-core');
  	const main_quantity = $cart_item.find('.cart-item-quantity').val();
  	const $target_line = $(`.cart-item[data-for-core="${main_added}"]`);

  	$target_line.find('.cart-item-quantity').val(main_quantity);
    const key = $target_line.attr('id');
    if (key) {
        update_object[key] = $cart_item.find('.cart-item-quantity').val();
    }
  	return update_object;
}

function updateCart(updates, is_checkout) {
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates },
        dataType: 'json',
        success: function () {
            if(is_checkout){
              $("[href$='checkout']").trigger('click');
            }
            else{
              document.location.href = '/cart';
            }
        },
        error: function (request, status, error) {
            console.log(request);
            console.log(status);
            console.log(error);
        }
    });
}

function isValidProductPage(previousURL){
    return (previousURL.includes('/collections') || previousURL.includes('/products'));
}

slate.cart = {

  init: function() {

    trackCartUpdate();
    trackItemRemoval();
  },
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }
      /* ADDED BY WPD APP */
      var WCP_JSON=[];
      if($('.wcp_json').length){    
        WCP_JSON=JSON.parse($('.wcp_json')[0].innerText);
        $.each(WCP_JSON.variants, function( index, value ) {
          if(variant.id == value.id){
            variant.price = value.price;  
            variant.compare_at_price = value.compare_at_price;       
            return false;
          }
        });      
      } 

      if(document.getElementsByClassName('wcp_vd_table').length!=0 && document.getElementById("vdtable") !=null){
        var source = document.getElementById("vdtable").innerHTML;
        var template = Handlebars.compile(source);
        if(document.getElementsByClassName('wcp_vd_table')[0] != undefined && document.getElementsByClassName('wcp_vd_table')[0].innerText != ""){
          var context = JSON.parse(document.getElementsByClassName('wcp_vd_table')[0].innerText);      
          var vdtable=[];
          vdtable['vdtable'] = context['wpd_'+variant.id];
          var html = template(vdtable);  		
          document.getElementById("wcp_vd_table").innerHTML = html;
        }
        else{
          document.getElementById("wcp_vd_table").innerHTML = "";
        }
      }
      /* ENDED BY WPD APP */
      
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);

      //
      // Start custom PDP option updates
      //
      // this._updatePDPCustomOption1(variant);
      // this._updatePDPCustomOption2(variant);
      // this._updatePDPCustomOption3(variant);
      // this._updatePDPCustomOption4(variant);
      // this._updatePDPCustomOption5(variant);
      // this._updatePDPCustomOption6(variant);
      // this._updatePDPCustomOption7(variant);
      //
      // End custom PDP option updates
      //

      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      // if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
      //   return;
      // }

      /* ADDED BY WPD APP */
      var WCP_JSON=[];
      if($('.wcp_json').length){    
        WCP_JSON=JSON.parse($('.wcp_json')[0].innerText);
        $.each(WCP_JSON.variants, function( index, value ) {
          if(variant.id == value.id){
            variant.price = value.price;  
            variant.compare_at_price = value.compare_at_price;       
            return false;
          }
        });      
      } 

      if(document.getElementsByClassName('wcp_vd_table').length!=0 && document.getElementById("vdtable") !=null){
        var source = document.getElementById("vdtable").innerHTML;
        var template = Handlebars.compile(source);
        if(document.getElementsByClassName('wcp_vd_table')[0] != undefined && document.getElementsByClassName('wcp_vd_table')[0].innerText != ""){
          var context = JSON.parse(document.getElementsByClassName('wcp_vd_table')[0].innerText);      
          var vdtable=[];
          vdtable['vdtable'] = context['wpd_'+variant.id];
          var html = template(vdtable);  		
          document.getElementById("wcp_vd_table").innerHTML = html;
        }
        else{
          document.getElementById("wcp_vd_table").innerHTML = "";
        }
      }
      /* ENDED BY WPD APP */

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant changes.
     * update the SKU
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }
    
      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },



    // 
    // Start custom PDP option updates
    // 

    // /**
    //  * Trigger event when variant changes.
    //  * Update custom option on PDP
    //  *
    //  * @param  {object} variant - Currently selected variant
    //  * @return {event}
    //  */
    // _updatePDPCustomOption1: function(variant) {
    //   // if you need a condition use the following as a template:
    //   // if (variant.sku === this.currentVariant.sku) {
    //   //   return;
    //   // }

    //   this.$container.trigger({
    //     type: 'pdpCustomOption1',
    //     variant: variant
    //   });
    // },

    // /**
    //  * Trigger event when variant changes.
    //  * Update custom option on PDP
    //  *
    //  * @param  {object} variant - Currently selected variant
    //  * @return {event}
    //  */
    // _updatePDPCustomOption2: function(variant) {
    //   // if you need a condition use the following as a template:
    // if (variant.sku === this.currentVariant.sku) {
    //   //   return;
    //   // }

    //   this.$container.trigger({
    //     type: 'pdpCustomOption2',
    //     variant: variant
    //   });
    // },

    // /**
    //  * Trigger event when variant changes.
    //  * Update custom option on PDP
    //  *
    //  * @param  {object} variant - Currently selected variant
    //  * @return {event}
    //  */
    // _updatePDPCustomOption3: function(variant) {
    //   // if you need a condition use the following as a template:
    // if (variant.sku === this.currentVariant.sku) {
    //   //   return;
    //   // }

    //   this.$container.trigger({
    //     type: 'pdpCustomOption3',
    //     variant: variant
    //   });
    // },

    // /**
    //  * Trigger event when variant changes.
    //  * Update custom option on PDP
    //  *
    //  * @param  {object} variant - Currently selected variant
    //  * @return {event}
    //  */
    // _updatePDPCustomOption4: function(variant) {
    //   // if you need a condition use the following as a template:
    // if (variant.sku === this.currentVariant.sku) {
    //   //   return;
    //   // }

    //   this.$container.trigger({
    //     type: 'pdpCustomOption4',
    //     variant: variant
    //   });
    // },

    // /**
    //  * Trigger event when variant changes.
    //  * Update custom option on PDP
    //  *
    //  * @param  {object} variant - Currently selected variant
    //  * @return {event}
    //  */
    // _updatePDPCustomOption5: function(variant) {
    //   // if you need a condition use the following as a template:
    // if (variant.sku === this.currentVariant.sku) {
    //   //   return;
    //   // }

    //   this.$container.trigger({
    //     type: 'pdpCustomOption5',
    //     variant: variant
    //   });
    // },

    // /**
    //  * Trigger event when variant changes.
    //  * Update custom option on PDP
    //  *
    //  * @param  {object} variant - Currently selected variant
    //  * @return {event}
    //  */
    // _updatePDPCustomOption6: function(variant) {
    //   // if you need a condition use the following as a template:
    // if (variant.sku === this.currentVariant.sku) {
    //   //   return;
    //   // }

    //   this.$container.trigger({
    //     type: 'pdpCustomOption6',
    //     variant: variant
    //   });
    // },

    // /**
    //  * Trigger event when variant changes.
    //  * Update custom option on PDP
    //  *
    //  * @param  {object} variant - Currently selected variant
    //  * @return {event}
    //  */
    // _updatePDPCustomOption7: function(variant) {
    //   // if you need a condition use the following as a template:
    // if (variant.sku === this.currentVariant.sku) {
    //   //   return;
    //   // }

    //   this.$container.trigger({
    //     type: 'pdpCustomOption7',
    //     variant: variant
    //   });
    // },


    // 
    // End custom PDP option updates
    //


    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[name="id"]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  // console.log('THUMBS', $(selectors.productThumbs));
  // console.log('FEATURED', $(".product-images-container " + selectors.productFeaturedImage));

  // Swap the featured image with the thumbnail image
  $(selectors.productThumbs).click(function(event) {
    event.preventDefault();
    $('.video-container').removeClass('active');
    if(this.dataset.videoId){
      $(".product-images-container " + selectors.productFeaturedImage).hide()
      $(`[data-video-id='${this.dataset.videoId}']`).addClass('active');
    }else{
      $(".product-images-container " + selectors.productFeaturedImage).show()
      $(".product-images-container " + selectors.productFeaturedImage).attr('src', $(this).attr('href'));
      $("[data-featherlight]").attr('data-featherlight', $(this).attr('data-master'));
      $("[data-zoom]").attr('data-zoom', $(this).attr('data-master'));
     
    }
   
  });

  //HOVER IMAGE 
  var ImageTrigger = document.querySelector(selectors.productFeaturedImage);
  var paneContainer = document.querySelector('.product-info-container');
  if(ImageTrigger && paneContainer && $(window).width() > 580){
    new Drift(ImageTrigger, {
      paneContainer: paneContainer,
      inlinePane: false,
    });
  }

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.$container.on('variantSKUChange' + this.namespace, this._updateSKU.bind(this));

    // fix wholesale price display messed up by product options app calculating for addons based on regular price
     const setOptionDiscount = (priceEl) => {
         if (!priceEl) {
          return;
         }
          const discount = Number(priceEl.dataset.discount || NaN);
         if(discount >= 1 || discount == 0){
            return;
         }
          document.querySelectorAll('.mw-apo-container .mw-option__price:not(.price-updated)').forEach((option) => {
              let originalPrice = Number(option.innerText.trim().replace('$', '').replace(",", "").replace("(", "").replace(")", "").replace("+", ""));
              let innerHtml =  `<s>${option.innerText}</s> <span>$${(originalPrice * discount).toFixed(2)}</span>`
              option.innerHTML = innerHtml
              option.classList.add('price-updated')
          }) 
    }
    
    const fixPricing = (priceEl, compareAtEl) => {
      if (!priceEl || !compareAtEl) {
        return;
      }

      const discountMultiplier = Number(priceEl.dataset.discount || NaN);

      if (isNaN(discountMultiplier) || discountMultiplier === 0) {
        return;
      }

      const price = Number(priceEl.textContent.trim().replace('$', '').replace(",", ""));
      
      if (price == priceEl.dataset.updatedPrice) {
        return;
      }
      
      const updatedPrice = (price * discountMultiplier).toFixed(2);

      priceEl.dataset.updatedPrice = updatedPrice;
      priceEl.innerHTML = '$' + updatedPrice;
      compareAtEl.innerHTML = '$' + price.toFixed(2);
    };

    // watch for product options app modifying price and update after with correction
    const priceEl = document.querySelector(selectors.productPrice);
    const compareAtEl = document.querySelector(selectors.comparePrice);
    const priceObserver = new MutationObserver(() => {
      fixPricing(priceEl, compareAtEl);
       setOptionDiscount(priceEl);
    });
    priceObserver.observe(priceEl, { childList: true });
   
    

    //
    // Start custom PDP option updates
    //
    // this.$container.on('pdpCustomOption1' + this.namespace, this._updatePDPCustomOption1.bind(this));
    // this.$container.on('pdpCustomOption2' + this.namespace, this._updatePDPCustomOption2.bind(this));
    // this.$container.on('pdpCustomOption3' + this.namespace, this._updatePDPCustomOption3.bind(this));
    // this.$container.on('pdpCustomOption4' + this.namespace, this._updatePDPCustomOption4.bind(this));
    // this.$container.on('pdpCustomOption5' + this.namespace, this._updatePDPCustomOption5.bind(this));
    // this.$container.on('pdpCustomOption6' + this.namespace, this._updatePDPCustomOption6.bind(this));
    // this.$container.on('pdpCustomOption7' + this.namespace, this._updatePDPCustomOption7.bind(this));
    //
    // End custom PDP option updates
    //

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        if ($(selectors.addToCart).attr('data-has-disclaimer') == 'true' && !$('.disclaimer input[name="chk_disclaimer"]').is(":checked")){
          $(selectors.addToCart, this.$container).prop('disabled', true);
        }
        else{
          $(selectors.addToCart, this.$container).prop('disabled', false);
        }

        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;
      // Update the SKU on the Product Page
      $('.variant-sku').html(variant.sku);
    },



    //
    // Start custom PDP option updates
    //

    // _updatePDPCustomOption1: function(evt) {
    //   // var variant = evt.variant;
    //   // Update the custom option on the Product Page
    //   $('#pdp_custom_option_1').html("<h2 style='color: lime;'>The Variant Was Changed</h2>");
    // },

    // _updatePDPCustomOption2: function(evt) {
    //   // var variant = evt.variant;
    //   // Update the custom option on the Product Page
    //   // $('#pdp_custom_option_2').html("some custom text");
    // },

    // _updatePDPCustomOption3: function(evt) {
    //   // var variant = evt.variant;
    //   // Update the custom option on the Product Page
    //   // $('#pdp_custom_option_3').html("some custom text");
    // },

    // _updatePDPCustomOption4: function(evt) {
    //   // var variant = evt.variant;
    //   // Update the custom option on the Product Page
    //   // $('#pdp_custom_option_4').html("some custom text");
    // },

    // _updatePDPCustomOption5: function(evt) {
    //   // var variant = evt.variant;
    //   // Update the custom option on the Product Page
    //   // $('#pdp_custom_option_5').html("some custom text");
    // },

    // _updatePDPCustomOption6: function(evt) {
    //   // var variant = evt.variant;
    //   // Update the custom option on the Product Page
    //   // $('#pdp_custom_option_6').html("some custom text");
    // },

    // _updatePDPCustomOption7: function(evt) {
    //   // var variant = evt.variant;
    //   // Update the custom option on the Product Page
    //   // $('#pdp_custom_option_7').html("some custom text");
    // },

    // 
    // End custom PDP option updates
    //



    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      // this method will swap the featured image with the variant image
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
      this.$featuredImage.attr('data-zoom', variant.featured_image.src); 
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  $('.object-card .img-responsive').on('load', function() {
    try {
      $('.object-card').matchHeight();
    } catch (e) {
      console.log(e);
    }
  });

  slate.cart.init();

});
